import request from '@/utils/request';


let server = {
    addAddress: '/address', // 添加收货地址
    modifyAddress: '/address', // 修改收货地址
    deleteAddress: '/address', // 删除收货地址
    obtainAddress: '/address', // 获取收货地址
};




//  添加收货地址
export function addAddress(params) {
	return request({
    	url: server.addAddress,
	    method: 'post',
	    data:params
  	})
}



//  修改收货地址
export function modifyAddress(params) {
	return request({
    	url: server.modifyAddress + '/' + params.id,
	    method: 'patch',
	    data:params
  	})
}



//  删除收货地址
export function deleteAddress(id) {
	return request({
    	url: server.deleteAddress + '/' + id,
	    method: 'delete',
  	})
}



//  获取收货地址
export function obtainAddress() {
	return request({
    	url: server.obtainAddress,
	    method: 'get'
  	})
}








// WEBPACK FOOTER //
// ./src/api/address.js